import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <h1>巨隆液压设备（集团）有限公司</h1>
          <p>JULONG (GROUP) HYDRAULIC PRESSURE EQUIPMENT CO., LTD.</p>
        </div>
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={closeMenu} className="nav-link">首页</Link>
          </li>
          <li>
            <Link to="/products" onClick={closeMenu} className="nav-link">产品中心</Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu} className="nav-link">关于我们</Link>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu} className="nav-link">联系我们</Link>
          </li>
        </ul>
        <button type="button" className="hamburger" onClick={toggleMenu} aria-label="菜单">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
